import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { LoginComponent } from './login/login.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        LoginComponent,
    ],
    exports: [
        RouterModule,
        LoginComponent,
    ]
})
export class PagesModule { }
